import Notify from '@/config/mixins/notify'
export default {
    data() {
        return {
            dados: {
                cep: '',
                rua: '',
                num: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: ''
            }
        }
    },
    mixins: [Notify],
    methods: {
        buscaCep() {
            if ( this.dados.cep.length < 9 ){
                this.dados.rua = '';
                this.dados.bairro = '';
                this.dados.cidade = '';
                this.dados.uf = '';
                this.msg = '';
            }else{
                this.$http.get(this.$urlAPI + "cep/" + this.dados.cep)
                    .then(response => {
                        if (response.data.erro) {
                            this.danger('CEP não localizado!')
                            this.msg = 'CEP não localizado!';
                        } else {
                            this.dados.rua = response.data.logradouro;
                            this.dados.bairro = response.data.bairro;
                            this.dados.cidade = response.data.localidade;
                            this.dados.uf = response.data.uf;
                            this.msg = '';
                        }
                    })
                    .catch(e => {
                        this.danger('Servidor de CEP fora do ar, tente novamente mais tarde!');
                    })
            }
        },
    }
}
